import React, { useState } from "react";
import {
  Box,
  Toolbar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Header from "./Header";
import Sidebar from "./Sidebar";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const sidebarWidth = 280;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {/* AppBar */}
      <Header
        sidebarOpen={sidebarOpen}
        onSidebarToggle={handleSidebarToggle}
        isMobile={isMobile}
        sidebarWidth={sidebarWidth}
      />

      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onToggle={handleSidebarToggle}
        variant={isMobile ? "temporary" : "persistent"}
      />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundColor: "background.default",
          transition: theme.transitions.create(["margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          ml: sidebarOpen && !isMobile ? `${sidebarWidth}px` : 0,
        }}
      >
        {/* Toolbar spacer */}
        <Toolbar />

        {/* Page Content */}
        <Box
          sx={{
            p: 3,
            minHeight: "calc(100vh - 64px)", // 64px è l'altezza della toolbar
            width: sidebarOpen && !isMobile 
              ? `calc(100vw - ${sidebarWidth}px - 64px)` // 64px per padding
              : `calc(100vw - 64px)`, // 64px per padding quando sidebar è chiusa
          }}
        >
          <div className="container">
          {children}
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
